import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { ITab } from './itab.interface';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NHATestDirective } from '../../directives/test/test.directive';
import { RouterLinkActive, RouterLink, QueryParamsHandling } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { NHAChipComponent } from '../chip';

@Component({
	selector: 'nha-tab-group',
	templateUrl: './tab-group.component.html',
	styleUrls: ['./tab-group.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [CommonModule, MatTabsModule, RouterLinkActive, NHATestDirective, RouterLink, MatIconModule, NHAChipComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NHATabGroupComponent implements OnInit {
	@Input() tabs$: Observable<ITab[]>;
	@Input() tabs: ITab[] = [];
	@Input() light: boolean = false;
	@Input() isVertical: boolean = false;
	/** How tab navigation treats existing query params. Defaults to Angular's drop behavior; set to
	 * 'preserve' when the current query params (e.g. a marking-period hint) must survive tab switches. */
	@Input() queryParamsHandling: QueryParamsHandling | null = null;

	@Output() linkClicked: EventEmitter<void> = new EventEmitter();

	@HostBinding('class.dark-theme') _dark: boolean = false;
	@HostBinding('class.vertical') _vertical: boolean = false;

	constructor() {}

	ngOnInit(): void {
		this._dark = !this.light;
		this._vertical = this.isVertical;
	}

	onLinkClick(): void {
		this.linkClicked.emit();
	}
}
